class AddToCartV2 extends HTMLElement {
  constructor() {
    super();
    console.log('AddToCartV2 constructor called');
    this.attachShadow({ mode: 'open' });
    
    // Default values
    this.productId = this.getAttribute('product-id');
    this.sectionId = this.getAttribute('section-id');
    this.productUrl = this.getAttribute('product-url');
    this.buttonText = this.getAttribute('button-text') || 'Add to cart';
    this.initialAvailable = this.getAttribute('initial-available');
    this.isLoading = false;
    this.quantity = 1;
    this.selectedAccessories = [];
    this.selectedGifts = [];
    this._boundAccessoriesChangeHandler = null;
    
    console.log('AddToCartV2 attributes:', {
      productId: this.productId,
      sectionId: this.sectionId,
      productUrl: this.productUrl,
      buttonText: this.buttonText,
      initialAvailable: this.initialAvailable
    });
    
    // Initialize arrays to avoid null errors
    if (!Array.isArray(this.selectedAccessories)) {
      this.selectedAccessories = [];
    }
    if (!Array.isArray(this.selectedGifts)) {
      this.selectedGifts = [];
    }
    
    this.render();
  }
  
  connectedCallback() {
    console.log('AddToCartV2 connectedCallback called');
    this.setupEventListeners();
    // Check initial availability after a short delay to ensure variant-cards-v2 is ready
    setTimeout(() => {
      this.checkInitialVariantAvailability();
    }, 200);
  }
  
  static get observedAttributes() {
    return ['product-id', 'section-id', 'product-url', 'button-text', 'initial-available'];
  }
  
  attributeChangedCallback(name, oldValue, newValue) {
    if (oldValue !== newValue) {
      switch (name) {
        case 'product-id':
          this.productId = newValue;
          break;
        case 'section-id':
          this.sectionId = newValue;
          break;
        case 'product-url':
          this.productUrl = newValue;
          break;
        case 'button-text':
          this.buttonText = newValue;
          this.render();
          this.setupEventListeners();
          break;
        case 'initial-available':
          this.initialAvailable = newValue;
          break;
      }
    }
  }
  
  render() {
    console.log('AddToCartV2 render called');
    try {
      this.shadowRoot.innerHTML = `
        <style>
          .product-actions {
            width: 100%;
          }
          
          .btn-add-to-cart {
            display: flex;
            align-items: center;
            justify-content: center;
            background: #c9302c;
            color: #fff;
            border: none;
            padding: 12px 30px;
            font-size: 16px;
            font-weight: 600;
            border-radius: 6px;
            cursor: pointer;
            transition: all 0.2s ease;
            width: 100%;
            height: 42px;
          }
          
          .btn-add-to-cart:hover {
            background: #a82824;
          }
          
          .btn-add-to-cart:disabled {
            background: #8a2220;
            cursor: not-allowed;
            opacity: 0.7;
          }
          
          .btn-add-to-cart svg {
            margin-left: 10px;
          }
          
          .add-to-cart-success {
            position: fixed;
            top: 20px;
            right: 20px;
            background: #28a745;
            color: #fff;
            padding: 15px 20px;
            border-radius: 4px;
            box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
            display: flex;
            align-items: center;
            opacity: 0;
            transform: translateY(-20px);
            transition: all 0.3s ease;
            z-index: 1000;
            pointer-events: none;
          }
          
          .add-to-cart-success.show {
            opacity: 1;
            transform: translateY(0);
            pointer-events: auto;
          }
          
          .add-to-cart-success svg {
            margin-right: 10px;
          }
        </style>
        <div class="product-actions">
          <form action="javascript:void(0);" method="post" id="product-form">
            <input type="hidden" name="id" id="product-select">
            <input type="hidden" name="product-id" value="${this.productId || ''}">
            <input type="hidden" name="section-id" value="${this.sectionId || ''}">
            <input type="hidden" name="form_type" value="product">
            <input type="hidden" name="utf8" value="✓">
            <input type="hidden" name="quantity" id="quantity-input" value="${this.quantity}">
            <button type="submit" class="btn-add-to-cart" name="add" id="add-to-cart" ${this.isLoading ? 'disabled' : ''}>
              ${this.isLoading ? 'Adding...' : this.buttonText}
              <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                <path d="M6 6h15l-1.5 9h-12z"/>
                <circle cx="9" cy="20" r="1"/>
                <circle cx="18" cy="20" r="1"/>
                <path d="M6 6L4 2H1"/>
              </svg>
            </button>
          </form>
        </div>
        <div id="add-to-cart-success" class="add-to-cart-success">
          <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
            <path d="M22 11.08V12a10 10 0 1 1-5.93-9.14"/>
            <polyline points="22 4 12 14.01 9 11.01"/>
          </svg>
          <span>Added to cart successfully!</span>
        </div>
      `;
      console.log('AddToCartV2 render completed successfully');
    } catch (error) {
      console.error('Error in AddToCartV2 render:', error);
    }
  }
  
  setupEventListeners() {
    const productForm = this.shadowRoot.getElementById('product-form');
    const addToCartBtn = this.shadowRoot.getElementById('add-to-cart');
    
    if (this._boundAccessoriesChangeHandler) {
      document.removeEventListener('accessories-change', this._boundAccessoriesChangeHandler);
    }
    this._boundAccessoriesChangeHandler = (e) => {
      console.log('accessories-change event received:', e.detail);
      const selectedItems = e.detail.selectedItems || [];
      this.selectedAccessories = selectedItems.filter(item => item.type === 'accessory');
      console.log('Selected accessories:', this.selectedAccessories);
      console.log('Selected gifts:', this.selectedGifts);
    };
    document.addEventListener('accessories-change', this._boundAccessoriesChangeHandler);
    
    // Listen to variant change events to check availability
    const variantCards = document.querySelector('variant-cards-v2');
    if (variantCards) {
      variantCards.addEventListener('variant-change', (e) => {
        this.updateButtonAvailability(e.detail.available);
      });
    }
    
    // Initialize accessories and gifts from accessories-section-v2
    setTimeout(() => {
      this.initializeAccessoriesAndGifts();
    }, 100);
    
    if (productForm && addToCartBtn) {
      productForm.addEventListener('submit', (e) => {
        e.preventDefault();
        e.stopPropagation();
        
        // Check if button is disabled due to sold out
        if (addToCartBtn.disabled && !this.isLoading) {
          return;
        }
        
        console.log('Form submit event triggered');
        console.log('this.quantity:', this.quantity);
        
        // Get variant ID from main DOM's hidden input
        const mainProductSelect = document.getElementById('product-select');
        const variantId = mainProductSelect ? mainProductSelect.value : null;
        const quantityInput = this.shadowRoot.getElementById('quantity-input');
        
        console.log('quantityInput element:', quantityInput);
        console.log('quantityInput.value:', quantityInput ? quantityInput.value : 'Not found');
        
        const quantity = quantityInput ? quantityInput.value : this.quantity;
        
        console.log('Form submitted with:', { variantId, quantity });
        console.log('Parsed values:', { variantId: parseInt(variantId), quantity: parseInt(quantity) });
        
        if (!variantId) {
          // alert('Please select a product variant');
          return;
        }
        
        this.addToCart(parseInt(variantId), parseInt(quantity));
      });
    }
  }
  
  // Check initial variant availability on page load
  checkInitialVariantAvailability() {
    console.log('checkInitialVariantAvailability called');
    console.log('initialAvailable attribute:', this.initialAvailable);
    
    // First check if we have initialAvailable attribute (for single variant products)
    if (this.initialAvailable !== null && this.initialAvailable !== undefined) {
      const isAvailable = this.initialAvailable === 'true';
      console.log('Using initialAvailable attribute, isAvailable:', isAvailable);
      this.updateButtonAvailability(isAvailable);
      return;
    }
    
    // Otherwise check variant-cards-v2 (for multi-variant products)
    const variantCards = document.querySelector('variant-cards-v2');
    console.log('variantCards element:', variantCards);
    
    if (variantCards) {
      console.log('variantCards.variants:', variantCards.variants);
      // Access the variants array directly from the component
      if (variantCards.variants && Array.isArray(variantCards.variants)) {
        const selectedVariantId = variantCards.selectedVariantId || (typeof variantCards.getSelectedVariantId === 'function' ? variantCards.getSelectedVariantId() : null);
        console.log('selectedVariantId:', selectedVariantId);
        if (selectedVariantId) {
          const selectedVariant = variantCards.variants.find(v => v.id == selectedVariantId);
          console.log('selectedVariant:', selectedVariant);
          if (selectedVariant) {
            console.log('Calling updateButtonAvailability with available:', selectedVariant.available);
            this.updateButtonAvailability(selectedVariant.available);
          }
        }
      } else {
        console.log('variantCards.variants is not available yet');
      }
    } else {
      console.log('variantCards element not found');
    }
  }
  
  // Update add to cart button based on variant availability
  updateButtonAvailability(isAvailable) {
    console.log('updateButtonAvailability called with isAvailable:', isAvailable);
    const addToCartBtn = this.shadowRoot.getElementById('add-to-cart');
    console.log('addToCartBtn element:', addToCartBtn);
    if (!addToCartBtn) return;
    
    if (isAvailable) {
      console.log('Enabling button');
      addToCartBtn.disabled = this.isLoading;
      addToCartBtn.innerHTML = `
        ${this.isLoading ? 'Adding...' : this.buttonText}
        <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
          <path d="M6 6h15l-1.5 9h-12z"/>
          <circle cx="9" cy="20" r="1"/>
          <circle cx="18" cy="20" r="1"/>
          <path d="M6 6L4 2H1"/>
        </svg>
      `;
    } else {
      console.log('Disabling button - SOLD OUT');
      addToCartBtn.disabled = true;
      addToCartBtn.innerHTML = `
        Sold Out
        <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
          <path d="M6 6h15l-1.5 9h-12z"/>
          <circle cx="9" cy="20" r="1"/>
          <circle cx="18" cy="20" r="1"/>
          <path d="M6 6L4 2H1"/>
        </svg>
      `;
    }
  }
  
  async addToCart(variantId, quantity) {
    const addToCartBtn = this.shadowRoot.getElementById('add-to-cart');
    if (!addToCartBtn) return;

    // Prevent duplicate calls
    if (this.isLoading) {
      console.warn('addToCart already in progress, ignoring duplicate call');
      return;
    }

    console.log('addToCart called with:', { variantId, quantity });
    
    // Double-check the quantity input value
    const quantityInput = this.shadowRoot.getElementById('quantity-input');
    console.log('Quantity input value:', quantityInput ? quantityInput.value : 'Not found');
    
    this.isLoading = true;
    addToCartBtn.disabled = true;
    addToCartBtn.innerHTML = `
      Adding...
      <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
        <path d="M6 6h15l-1.5 9h-12z"/>
        <circle cx="9" cy="20" r="1"/>
        <circle cx="18" cy="20" r="1"/>
        <path d="M6 6L4 2H1"/>
      </svg>
    `;
    
    try {
      // Calculate sections URL
      const sectionsUrl = this.productUrl ? this.productUrl.replace(/^https?:\/\/[^\/]+/, '') : '';
      
      // Get cart drawer sections to render
      const cartDrawer = document.querySelector('cart-drawer');
      let sections = [];
      if (cartDrawer && typeof cartDrawer.getSectionsToRender === 'function') {
        try {
          const sectionsToRender = cartDrawer.getSectionsToRender();
          if (sectionsToRender && Array.isArray(sectionsToRender)) {
            sections = sectionsToRender.map((section) => section.id);
          }
        } catch (e) {
          console.error('Error getting sections to render:', e);
        }
      }
      
      // 1. Add main product - form-data request with hidden inputs
      console.log('=== addToCart START ===');
      console.log('Main product - variantId:', variantId, 'quantity:', quantity);
      console.log('this.selectedAccessories BEFORE addMainProduct:', this.selectedAccessories);
      console.log('this.selectedAccessories length:', this.selectedAccessories ? this.selectedAccessories.length : 'undefined/null');
      await this.addMainProduct(variantId, quantity);
      
      // 2. Add accessories and gifts in a single JSON request
      const additionalItems = [];
      
      console.log('this.selectedAccessories AFTER addMainProduct:', this.selectedAccessories);
      console.log('this.selectedGifts:', this.selectedGifts);
      
      // Add selected compatible accessories (filter out main product to prevent duplicate)
      if (this.selectedAccessories && this.selectedAccessories.length > 0) {
        console.log('Found', this.selectedAccessories.length, 'accessories to add');
        this.selectedAccessories.forEach(accessory => {
          console.log('Adding accessory:', accessory, '- accessory.id:', accessory.id, 'variantId:', variantId);
          console.log('Is accessory.id === variantId?', accessory.id === variantId);
          // Skip if this accessory is actually the main product (prevent duplicate)
          if (accessory.id === variantId) {
            console.warn('WARNING: Skipping accessory because it matches main product variantId:', variantId);
            return;
          }
          additionalItems.push({
            id: accessory.id,
            quantity: 1,
            properties: {
              _is_accessory: true,
              'Accessory Name': accessory.title || ''
            }
          });
        });
      } else {
        console.log('No accessories selected, additionalItems will be empty');
      }
      
      // Add free gifts
      // if (this.selectedGifts && this.selectedGifts.length > 0) {
      //   this.selectedGifts.forEach(gift => {
      //     console.log('Adding gift:', gift);
      //     additionalItems.push({
      //       id: gift.id,
      //       quantity: 1,
      //       properties: {
      //         _is_gift: true
      //       }
      //     });
      //   });
      // }
      
      console.log('additionalItems to send:', additionalItems);
      
      // Send single request for all accessories and gifts
      if (additionalItems.length > 0) {
        await this.addMultipleItems(additionalItems);
      }
      
      // 3. Call /cart/update.js to get sections and update cart drawer (with 300ms delay)
      let updateResponse = null;
      if (sections && sections.length > 0) {
        await new Promise(resolve => setTimeout(resolve, 300));
        updateResponse = await this.updateCartWithSections(sections, sectionsUrl);
      }
      
      // Update cart drawer content using the update response
      if (cartDrawer && typeof cartDrawer.renderContents === 'function' && updateResponse && updateResponse.sections) {
        try {
          console.log('Using sections from /cart/update.js:', updateResponse.sections);
          cartDrawer.renderContents(updateResponse);
        } catch (e) {
          console.error('Error rendering cart drawer contents:', e);
        }
      }
      
      // Get updated cart data
      const cartResponse = await fetch('/cart.json', {
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json',
        },
      });
      const cartData = await cartResponse.json();
      
      // Update cart count
      this.updateCartCount(cartData.item_count);
      
      // Dispatch success event
      this.dispatchEvent(new CustomEvent('add-to-cart-success', { detail: { cartCount: cartData.item_count, variantId, quantity } }));
      
    } catch (error) {
      console.error('Error adding to cart:', error);
      // alert('Error adding to cart: ' + error.message);
      
      // Dispatch error event
      this.dispatchEvent(new CustomEvent('add-to-cart-error', { detail: { error: error.message } }));
    } finally {
      this.isLoading = false;
      // Re-check availability when loading is done
      this.checkInitialVariantAvailability();
    }
  }
  
  // Add main product using form-data with hidden inputs
  async addMainProduct(variantId, quantity) {
    const formData = new FormData();
    
    // Get product-single__form and collect all hidden inputs
    const productForm = document.querySelector('.product-single__form');
    if (productForm) {
      const hiddenInputs = productForm.querySelectorAll('input[type="hidden"]');
      hiddenInputs.forEach(input => {
        if (input.name && input.value && !input.disabled) {
          formData.append(input.name, input.value);
        }
      });
    }
    
    // Ensure variant id and quantity are included
    formData.set('id', variantId);
    formData.set('quantity', quantity);
    
    console.log('Adding main product with form-data:', Array.from(formData.entries()));
    
    const response = await fetch('/cart/add.json', {
      method: 'POST',
      body: formData
    });
    
    if (!response.ok) {
      const errorData = await response.json();
      throw new Error(errorData.description || errorData.message || 'Failed to add main product');
    }
    
    return await response.json();
  }
  
  // Add multiple items (accessories and gifts) in a single JSON request
  async addMultipleItems(items) {
    console.log('Adding multiple items with JSON:', items);
    
    const requestBody = {
      items: items
    };
    
    const response = await fetch('/cart/add.json', {
      method: 'POST',
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(requestBody)
    });
    
    if (!response.ok) {
      const errorData = await response.json();
      console.warn('Warning: Failed to add items:', errorData);
    }
    
    return response.ok ? await response.json() : null;
  }
  
  // Call /cart/update.js to get sections
  async updateCartWithSections(sections, sectionsUrl) {
    if (!sections || sections.length === 0) {
      return null;
    }
    
    const formData = new FormData();
    formData.append('sections', sections.join(','));
    formData.append('sections_url', sectionsUrl || window.location.pathname);
    
    try {
      const response = await fetch('/cart/update.js', {
        method: 'POST',
        body: formData
      });
      
      if (response.ok) {
        return await response.json();
      }
    } catch (e) {
      console.error('Error calling /cart/update.js:', e);
    }
    
    return null;
  }
  
  updateCartCount(cartCount) {
    // Update cart count bubbles
    const cartCountBubbles = document.querySelectorAll('.cart-count-bubble');
    cartCountBubbles.forEach(bubble => {
      const countSpan = bubble.querySelector('span[aria-hidden="true"]');
      if (countSpan) {
        countSpan.textContent = cartCount;
      }
    });
    
    // If cart was empty and now has items, create the cart count bubble
    if (cartCount > 0 && cartCountBubbles.length === 0) {
      const cartLinks = document.querySelectorAll('a[href="/cart"]');
      cartLinks.forEach(cartLink => {
        const existingBubble = cartLink.querySelector('.cart-count-bubble');
        if (!existingBubble) {
          const bubble = document.createElement('div');
          bubble.className = 'cart-count-bubble';
          const countSpan = document.createElement('span');
          countSpan.setAttribute('aria-hidden', 'true');
          countSpan.textContent = cartCount;
          bubble.appendChild(countSpan);
          
          const visuallyHiddenSpan = document.createElement('span');
          visuallyHiddenSpan.className = 'visually-hidden';
          visuallyHiddenSpan.textContent = cartCount + ' items in cart';
          bubble.appendChild(visuallyHiddenSpan);
          
          cartLink.appendChild(bubble);
        }
      });
    }
    
    // Update other cart count elements
    const otherCartCountElements = document.querySelectorAll('[data-cart-count], .cart-count, .cart-item-count');
    otherCartCountElements.forEach(element => {
      element.textContent = cartCount;
    });
  }
  
  openCartDrawer() {
    const cartDrawer = document.querySelector('cart-drawer');
    if (cartDrawer) {
      if (typeof cartDrawer.open === 'function') {
        cartDrawer.open();
      } else {
        customElements.whenDefined('cart-drawer').then(() => {
          const drawer = document.querySelector('cart-drawer');
          if (drawer && typeof drawer.open === 'function') {
            drawer.open();
          }
        });
      }
    }
  }
  
  showSuccessMessage() {
    const successMessage = this.shadowRoot.getElementById('add-to-cart-success');
    if (successMessage) {
      successMessage.classList.add('show');
      setTimeout(() => {
        successMessage.classList.remove('show');
      }, 3000);
    }
  }
  
  // Public method to set variant ID
  setVariantId(variantId) {
    const mainProductSelect = document.getElementById('product-select');
    if (mainProductSelect) {
      mainProductSelect.value = variantId;
    }
  }
  
  // Public method to set quantity
  setQuantity(quantity) {
    console.log('setQuantity called with value:', quantity);
    console.log('this.quantity before update:', this.quantity);
    
    this.quantity = quantity;
    const quantityInput = this.shadowRoot.getElementById('quantity-input');
    
    console.log('quantityInput element:', quantityInput);
    
    if (quantityInput) {
      quantityInput.value = quantity;
      console.log('quantityInput.value after update:', quantityInput.value);
      console.log('this.quantity updated to:', this.quantity);
    } else {
      console.error('quantityInput element not found!');
    }
  }
  
  // Initialize accessories and gifts from accessories-section-v2
  initializeAccessoriesAndGifts() {
    const accessoriesSection = document.querySelector('accessories-section-v2');
    if (accessoriesSection && typeof accessoriesSection.getSelectedAccessories === 'function') {
      // Get selected accessories
      const selectedAccessories = accessoriesSection.getSelectedAccessories();
      this.selectedAccessories = selectedAccessories;
      
      // Get free gifts using the public method
      // if (typeof accessoriesSection.getFreeGifts === 'function') {
      //   this.selectedGifts = accessoriesSection.getFreeGifts();
      // }
      
      console.log('Initialized accessories:', this.selectedAccessories);
      console.log('Initialized gifts:', this.selectedGifts);
    }
  }
}

customElements.define('add-to-cart-v2', AddToCartV2);